import React, { FC } from 'react'
import { useField } from 'formik'
import { useTranslations } from 'next-intl'
import style from './FormDegreeField.module.css'
import { PositionOption } from '../PositionOption/PositionOption'
import { CreatableSelectField } from '../../CreatableSelectField/CreatableSelectField'
import { IFormValue } from '../../../validator/IFormValues'
import { FormFieldTypes } from '../../../emun/RegistrationFormFieldTypes'
import { IDictionaryItem } from '../../../interfaces/IDictionaryItem'
import { useDegreeGetList } from '../../../api/query/useDegreeGetList'
import { DEGREE_FIELD_NAME, DEGREE_FIELD_PLACEHOLDER } from '../constants'

const DEFAULT_MIN_SEARCH_LENGTH = 0

const renderItem = (option: IDictionaryItem, inputValue: IDictionaryItem, isActive: boolean) => (
  <PositionOption isActive={isActive} optionName={option.name} inputValue={inputValue.name} />
)

const renderValue = (inputValue: IDictionaryItem) => inputValue.name

type FormDegreeFieldFieldProps = {
  validate?: (name: string) => (currentValue: IFormValue) => Promise<string>
}

export const FormDegreeField: FC<FormDegreeFieldFieldProps> = ({ validate }) => {
  const t = useTranslations()
  const { data } = useDegreeGetList()
  const fieldName = t(DEGREE_FIELD_NAME)
  const fieldPlaceholder = t(DEGREE_FIELD_PLACEHOLDER)
  const [field] = useField(FormFieldTypes.Degree)

  return (
    <CreatableSelectField<IDictionaryItem>
      inputClassName={style.FormDegreeField}
      name={field.name}
      label={fieldName}
      options={data}
      placeholder={fieldPlaceholder}
      renderItem={renderItem}
      renderValue={renderValue}
      minSearchLength={DEFAULT_MIN_SEARCH_LENGTH}
      minCharsToOpen={0}
      readonly
      validate={validate && validate(field.name)}
    />
  )
}

FormDegreeField.displayName = 'FormDegreeField'
